import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	positionExternalKey: {
		id: 'search_talent_position.external_position_key',
		defaultMessage: 'External key {positionExternalKey}',
		description: 'External ID of the position',
	},
	positionTitle: {
		id: 'search_talent_position.position_title',
		defaultMessage:
			'{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
		description: 'Position title with position key',
	},
});
